export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const imageToBase64 = async (file) => {
    let result = await convertBase64(file);
    result = result.substr(result.indexOf(",")+1);
    return result;
};

export const addBase64Prefix = function(base64CodedString){
    return 'data:image/png;base64,' + base64CodedString;
}

const logoFromConfig= localStorage.getItem("logo");
export {logoFromConfig};
